import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EPAWorklistDetails {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  EPAWorklistDetailsData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: EPAWorklistDetails = {
  isLoading: false,
  error: false,
  message: null,
  EPAWorklistDetailsData: [],
  Items: [],
  Pagination: [],
};

const EPAWorklistDetailsSlice = createSlice({
  name: "EPAWorklistDetails",
  initialState,
  reducers: {
    loadingEPAWorklistDetails: (
      state: EPAWorklistDetails,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setEPAWorklistDetails: (
      state: any,
      action: PayloadAction<EPAWorklistDetails>
    ) => {
      return action.payload;
    },
    clearData: (state: EPAWorklistDetails, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingEPAWorklistDetails, setEPAWorklistDetails, clearData } =
  EPAWorklistDetailsSlice.actions;
export default EPAWorklistDetailsSlice.reducer;
